import { render } from "./Archiv.vue?vue&type=template&id=868f1698&scoped=true"
import script from "./Archiv.vue?vue&type=script&lang=js"
export * from "./Archiv.vue?vue&type=script&lang=js"

import "./Archiv.vue?vue&type=style&index=0&id=868f1698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868f1698"]])

export default __exports__